// Language selector functionality
document.addEventListener("DOMContentLoaded", function () {
  const languageSelector = document.querySelector(".language-selector");
  if (!languageSelector) return;

  const button = languageSelector.querySelector("button");
  const dropdown = languageSelector.querySelector(".language-dropdown");

  // Toggle dropdown on button click
  button.addEventListener("click", function (e) {
    e.stopPropagation();
    dropdown.classList.toggle("hidden");
  });

  // Close dropdown when clicking outside
  document.addEventListener("click", function (e) {
    if (!languageSelector.contains(e.target)) {
      dropdown.classList.add("hidden");
    }
  });
});
